export enum MoveOutType {
  /**
   * legacy values for backwards compatibility
   * to be removed in the future
   */
  None,
  PmNonRenewal,
  TenantNonRenewal,
  Eviction,
  Other,

  /**
   * new enum values
   */
  Evict,
  Notice_Rented,
  Notice_Unrented,
  Vacant_Rented,
  Vacant_Unrented,
  Down,

  //FE only type
  NonPms = 100,
}
